(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fi-homepage"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fi-home]').forEach(function(home){
    var links=home.querySelectorAll('a[href^="#"]');
    links.forEach(function(link){link.addEventListener('click',function(event){var target=home.querySelector(link.getAttribute('href'));if(target){event.preventDefault();target.scrollIntoView({behavior:'smooth'});}});});
    var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduceMotion){home.classList.add('fi-motion-ready');}

    var heroCarousel=home.querySelector('[data-fi-hero-carousel]');
    if(heroCarousel){
      var heroSlides=Array.prototype.slice.call(heroCarousel.querySelectorAll('[data-fi-hero-slide]'));
      if(heroSlides.length>1&&!reduceMotion){
        var heroIndex=0;
        var heroSpeed=Math.max(3000,Number(heroCarousel.getAttribute('data-fi-hero-speed'))||5500);
        window.setInterval(function(){
          heroSlides[heroIndex].classList.remove('is-active');
          heroIndex=(heroIndex+1)%heroSlides.length;
          heroSlides[heroIndex].classList.add('is-active');
        },heroSpeed);
      }
    }

    var popup=home.querySelector('[data-fi-popup]');
    if(popup){
      var popupKey='fi-drop-offer-dismissed';
      var popupDismissed=false;
      try{popupDismissed=Number(window.localStorage.getItem(popupKey)||0)>Date.now();}catch(error){}
      function closePopup(){popup.hidden=true;document.documentElement.style.overflow='';try{window.localStorage.setItem(popupKey,String(Date.now()+604800000));}catch(error){}}
      function openPopup(){popup.hidden=false;document.documentElement.style.overflow='hidden';var email=popup.querySelector('input[type="email"]');if(email){window.setTimeout(function(){email.focus();},80);}}
      popup.querySelectorAll('[data-fi-popup-close]').forEach(function(button){button.addEventListener('click',closePopup);});
      document.addEventListener('keydown',function(event){if(event.key==='Escape'&&!popup.hidden){closePopup();}});
      if(!popupDismissed){window.setTimeout(openPopup,3500);}
    }

    var glow=document.createElement('span');
    glow.className='fi-home__cursor-glow';
    glow.setAttribute('aria-hidden','true');
    home.appendChild(glow);

    var hero=home.querySelector('.fi-hero');
    var framePending=false;
    function updateHero(){
      framePending=false;
      if(!hero){return;}
      var rect=hero.getBoundingClientRect();
      var distance=Math.max(hero.offsetHeight*.72,1);
      var progress=Math.min(1,Math.max(0,-rect.top/distance));
      var mobile=window.innerWidth<990;
      home.style.setProperty('--fi-hero-y',(progress*(mobile?-115:-190))+'px');
      home.style.setProperty('--fi-hero-scale',(1+progress*.055).toFixed(3));
      home.style.setProperty('--fi-hero-opacity',Math.max(0,1-progress*1.08).toFixed(3));
      home.style.setProperty('--fi-copy-y',(progress*(mobile?-34:-72))+'px');
    }
    function requestHeroUpdate(){if(!framePending){framePending=true;window.requestAnimationFrame(updateHero);}}
    updateHero();
    window.addEventListener('scroll',requestHeroUpdate,{passive:true});
    window.addEventListener('resize',requestHeroUpdate,{passive:true});

    var revealItems=home.querySelectorAll('.fi-intro,.fi-manifesto,.fi-category,.fi-nightfall,.fi-code,.fi-signup');
    var revealObserver=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}});
    },{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    revealItems.forEach(function(item){revealObserver.observe(item);});

    if(window.matchMedia('(hover: hover) and (pointer: fine)').matches){
      home.addEventListener('pointerenter',function(){home.classList.add('fi-pointer-active');});
      home.addEventListener('pointerleave',function(){home.classList.remove('fi-pointer-active');});
      home.addEventListener('pointermove',function(event){home.style.setProperty('--fi-pointer-x',event.clientX+'px');home.style.setProperty('--fi-pointer-y',event.clientY+'px');},{passive:true});
    }
    home.querySelectorAll('[data-fi-gallery]').forEach(function(gallery){
      var track=gallery.querySelector('[data-fi-gallery-track]');
      var slides=Array.prototype.slice.call(gallery.querySelectorAll('[data-fi-slide]'));
      var thumbs=Array.prototype.slice.call(gallery.querySelectorAll('[data-fi-thumb]'));
      var current=gallery.querySelector('[data-fi-current]');
      if(!track||slides.length<2){return;}
      function selectSlide(index){
        var safeIndex=(index+slides.length)%slides.length;
        track.scrollTo({left:slides[safeIndex].offsetLeft,behavior:'smooth'});
      }
      function updateGallery(){
        var index=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));
        index=Math.min(slides.length-1,Math.max(0,index));
        thumbs.forEach(function(thumb,i){thumb.classList.toggle('is-active',i===index);thumb.setAttribute('aria-current',i===index?'true':'false');});
        if(current){current.textContent=String(index+1).padStart(2,'0');}
      }
      thumbs.forEach(function(thumb){thumb.addEventListener('click',function(){selectSlide(Number(thumb.getAttribute('data-fi-index')));});});
      var previous=gallery.querySelector('[data-fi-prev]');
      var next=gallery.querySelector('[data-fi-next]');
      if(previous){previous.addEventListener('click',function(){var index=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));selectSlide(index-1);});}
      if(next){next.addEventListener('click',function(){var index=Math.round(track.scrollLeft/Math.max(track.clientWidth,1));selectSlide(index+1);});}
      var galleryFrame=false;
      track.addEventListener('scroll',function(){if(!galleryFrame){galleryFrame=true;window.requestAnimationFrame(function(){galleryFrame=false;updateGallery();});}},{passive:true});
      updateGallery();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fi-password-gate"]) return;
  try {
    
  (() => {
    const initIntro = () => {
      document.querySelectorAll('[data-fi-intro]').forEach((intro) => {
        if (intro.dataset.ready === 'true') return;
        intro.dataset.ready = 'true';
        const start = intro.querySelector('[data-fi-intro-start]');
        if (!start) return;

        start.addEventListener('click', () => {
          start.disabled = true;
          intro.classList.add('is-playing');
        }, { once: true });

        intro.addEventListener('animationend', (event) => {
          if (event.target === intro && intro.classList.contains('is-playing')) {
            intro.hidden = true;
          }
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initIntro, { once: true });
    } else {
      initIntro();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  document.querySelectorAll('[data-fi-about]').forEach(function(page){
    var items=page.querySelectorAll('.fi-about__statement blockquote,.fi-about__closing>*');
    items.forEach(function(item){item.setAttribute('data-fi-reveal','');});
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    items.forEach(function(item){observer.observe(item);});
  });

  } catch(e) { console.error(e); }
})();
})();
